import React from "react";
import {
  Box,
  Paper,
  Stack,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
  TextAlignLeftIcon,
  TextAlignCenterIcon,
  TextAlignRightIcon,
  TextAlignJustifyCenterIcon,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const ExclusiveSelection = () => {
  const [alignment, setAlignment] = React.useState("left");

  const handleAlignment = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Exclusive selection
        </Typography>
        <Typography variant={"body1"} color={"text.primary"}>
          With exclusive selection, selecting one option deselects any other.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor
            language={"js"}
            value={
              "const Index = () => {\n" +
              '  const [alignment, setAlignment] = React.useState("left");\n' +
              "\n" +
              "  const handleAlignment = (event, newAlignment) => {\n" +
              "    setAlignment(newAlignment);\n" +
              "  };\n" +
              "\n" +
              "  return (\n" +
                "           <ToggleButtonGroup\n" +
                "              value={alignment}\n" +
                "              exclusive\n" +
                "              onChange={handleAlignment}\n" +
                "            >\n" +
                "              <ToggleButton value=\"left\">\n" +
                "                <TextAlignLeftIcon />\n" +
                "              </ToggleButton>\n" +
                "              <ToggleButton value=\"center\">\n" +
                "                <TextAlignCenterIcon />\n" +
                "              </ToggleButton>\n" +
                "              <ToggleButton value=\"right\">\n" +
                "                <TextAlignRightIcon />\n" +
                "              </ToggleButton>\n" +
                "              <ToggleButton value=\"justify\">\n" +
                "                <TextAlignJustifyCenterIcon />\n" +
                "              </ToggleButton>\n" +
                "            </ToggleButtonGroup>"+
              "  );\n" +
              "};\n"
            }
          >
            <ToggleButtonGroup
              value={alignment}
              exclusive
              onChange={handleAlignment}
            >
              <ToggleButton value="left">
                <TextAlignLeftIcon />
              </ToggleButton>
              <ToggleButton value="center">
                <TextAlignCenterIcon />
              </ToggleButton>
              <ToggleButton value="right">
                <TextAlignRightIcon />
              </ToggleButton>
              <ToggleButton value="justify">
                <TextAlignJustifyCenterIcon />
              </ToggleButton>
            </ToggleButtonGroup>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default ExclusiveSelection;
